import { Route } from '@angular/router'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { IncidentExportComponent } from './incident-export/incident-export.component'

export const incidentRoutes: Route[] = [
  {
    path: 'incidents/export',
    component: IncidentExportComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'exportIncidents'
    }
  }
]
